<div className="updateProgressSuccess">
  <div class="hug-tutor-modal-body">
    <div class="hug-graphic-success mb-8">
      <img
        class="hug-graphic-success__bg"
        src="assets/images/tutor/hug-bg-success.svg"
        alt="HUG success background"
      />
      <img
        class="hug-graphic-success__starMain animate__animated animate__tada animate__infinite animate__slower"
        src="assets/images/tutor/hug-icon-star.svg"
        alt="HUG success star main"
      />
      <img
        class="hug-graphic-success__starSub1 animate__animated animate__tada animate__infinite animate__slow"
        src="assets/images/tutor/hug-icon-star.svg"
        alt="HUG success star sub1"
      />
      <img
        class="hug-graphic-success__starSub2 animate__animated animate__tada animate__infinite animate__slow"
        src="assets/images/tutor/hug-icon-star.svg"
        alt="HUG success star sub2"
      />
    </div>
    <h3 class="hug-h3 text-center mb-2">Congratulations</h3>
    <p class="text-center mb-5">Your changes have been successfully saved!</p>
    
    <div *ngFor="let passage of passages; let i = index" class="hug-percentage" >
      <h4 class="text-center mb-3">Passage {{ i + 1 }}: {{ passage.passage_name }}</h4>
      <div class="hug-percentage__row">
        <span class="hug-percentage__label">First attempt</span>
        <div
          class="hug-percentage__rail hug-percentage__rail--primary"
          role="progressbar"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuemax="100"
          [style.width.%]="getAcumenData1(passage)"
        >
          <span
            class="hug-percentage__value"
            [style.width.%]="getAcumenData1(passage)"
            role="progressbar"
          ></span>
        </div>
        <span class="ml-2" style="width: 36px; flex: 0 0 36px"
          >{{ getAcumenData1(passage) }}%</span
        >
      </div>
      <div class="hug-percentage__row">
        <span class="hug-percentage__label">Second attempt</span>
        <div
          class="hug-percentage__rail hug-percentage__rail--secondary"
          role="progressbar"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuemax="100"
          [style.width.%]="getAcumenData2(passage)"
        >
          <span
            class="hug-percentage__value"
            [style.width.%]="getAcumenData2(passage)"
            role="progressbar"
          ></span>
        </div>
        <span class="ml-2" style="width: 36px; flex: 0 0 36px"
          >{{ getAcumenData2(passage) }}%</span
        >
      </div>
    </div>
    <div class="text-center" style="margin-top: 1rem">
      <button
        class="hug-btn hug-btn--primary"
        mat-button
        color="primary"
        (click)="confirmAction()"
      >
        Ok
      </button>
    </div>
  </div>
</div>
